import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./slices/authSlice";
import dashboardSlice from "./slices/dashboardSlice";
import userSlice from "./slices/userSlice";
import trainerSlice from "./slices/trainerSlice";
import categorySlice from "./slices/categorySlice";
import taskSlice from "./slices/taskSlice";
import testSlice from "./slices/testSlice";
import discountSlice from "./slices/discountSlice";
import corporateProfileSlice from "./slices/corporateProfileSlice";
import subadminSlice from "./slices/subadminSlice";
import communityForum from "./slices/communityForum";
import languageSlice from "./slices/languageSlice";
import blogSlice from "./slices/blogSlice";
import animatedVideoSlice from "./slices/animatedVideoSlice";
import cmsSlice from "./slices/cmsSlice";
import chatSlice from "./slices/chatSlice";
import notificationSlice from "./slices/notificationSlice";
import complaintFeedbackSlice from "./slices/complaintFeedbackSlice";
import reportSlice from "./slices/reportSlice";
import subscriptionSlice from "./slices/subscriptionSlice";
import earningSlice from "./slices/earningSlice";
import contactUsSlice from "./slices/contactUsSlice";

export const store = configureStore({
  reducer: {
    auth: authSlice,
    dashboard: dashboardSlice,
    users: userSlice,
    trainers: trainerSlice,
    category: categorySlice,
    tasks: taskSlice,
    test:testSlice,
    discount:discountSlice,
    corporateProfile:corporateProfileSlice,
    subadmin:subadminSlice,
    communityForum:communityForum,
    blogs:blogSlice,
    language:languageSlice,
    animatedVideo:animatedVideoSlice,
    cms:cmsSlice,
    chat: chatSlice,
    notification: notificationSlice,
    complaintFeedback: complaintFeedbackSlice,
    report: reportSlice,
    subscription: subscriptionSlice,
    earning: earningSlice,
    contactUs: contactUsSlice
  },
  devTools: process.env.NODE_ENV === 'development',
});
